import React, { useEffect, useState } from "react";
import TextMedium from "../TextComponent/TextMedium";
import { ResponsivePie } from "@nivo/pie";
import { ReactComponent as LoadingStatusOperator } from "../../../build/images/loadingstatusoperator.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { useSelector } from "react-redux";
import { Tooltippy } from "../../../actions/Tippy";

let jsonRefactored = [];
let countOperators = 0;
let groupsPermission = [];
let data = [];
// let statusBox = [
// {
//   "id": "After Call Work",
//   "label": "After Call Work",
//   "value": 0,
//   "color": "#ffca28"
// },
// {
//   "id": "Pausado",
//   "label": "Pausado",
//   "value": 0,
//   "color": "#ED4E50"
// },
// {
//   "id": "Consulta",
//   "label": "Consulta",
//   "value": 0,
//   "color": "#1590b2"
// },
// {
//   "id": "Atendimento",
//   "label": "Atendimento",
//   "value": 0,
//   "color": "#8E24AA"
// },
// {
//   "id": "Livre",
//   "label": "Livre",
//   "value": 0,
//   "color": "#43A047"
// },
// {
//   "id": "Deslogado",
//   "label": "Deslogado",
//   "value": 0,
//   "color": "#B7BEC5"
// }
// ]

export default function CardStatusOperators({ title, classname = "" }) {
  // const DataStatusOperators = useSelector(state => state.datamanagerstatusoperators);
  const GroupsPermissionSupervisor = useSelector(
    (state) => state.grouppermissionsupervisor
  );
  const usersReduce = useSelector((state) => state.agents);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const [dataStatus, setDataStatus] = useState([]);

  useEffect(() => {
    if (FiltersManager.is_active) {
      data = [
        {
          id: "Atendimento",
          label: "Atendimento",
          value: 0,
          color: "#8E24AA",
        },
        {
          id: "Livre",
          label: "Livre",
          value: 0,
          color: "#43A047",
        },
        {
          id: "Deslogado",
          label: "Deslogado",
          value: 0,
          color: "#B7BEC5",
        },
        {
          id: "Pausado",
          label: "Pausado",
          value: 0,
          color: "#ED4E50",
        },
        {
          id: "AfterCallWork",
          label: "AfterCallWork",
          value: 0,
          color: "#ffca28",
        },
      ];
      countOperators = 0;
      let temp = [];

      if (GroupsPermissionSupervisor.length !== 0) {
        groupsPermission = GroupsPermissionSupervisor.map(
          (group) => group.usergroup
        );
      }

      if (usersReduce.length !== 0) {
        jsonRefactored = usersReduce;

        jsonRefactored = jsonRefactored.filter((filt) =>
          FiltersManager.filter_manager_group.includes(filt.id_grupo)
        );

        jsonRefactored.map((datum) => {
          if (datum.status === "LV" && datum.status_sip === "LV") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[1].value = data[1].value + 1;
          } else if (datum.status === "AT" && datum.status_sip === "AT") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[0].value = data[0].value + 1;
          } else if (datum.status === null && datum.status_sip === null) {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[2].value = data[2].value + 1;
          } else if (datum.status === null && datum.status_sip === "LV") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[1].value = data[1].value + 1;
          } else if (datum.status === "LV" && datum.status_sip === "BQ") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[3].value = data[3].value + 1;
          } else if (datum.status === "BQ" && datum.status_sip === "BQ") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[3].value = data[3].value + 1;
          } else if (datum.status === null && datum.status_sip === "BQ") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[3].value = data[3].value + 1;
          } else if (datum.status_sip === "LV" && datum.status === "AT") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[0].value = data[0].value + 1;
          } else if (datum.status_sip === "AT" && datum.status === null) {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[0].value = data[0].value + 1;
          } else if (datum.status_sip === "CHND" && datum.status != "CHND") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[0].value = data[0].value + 1;
          } else if (datum.status === "CHND" && datum.status_sip != "LV") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[0].value = data[0].value + 1;
          } else if (datum.status === "ACW" && datum.status_sip === "ACW") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[4].value = data[4].value + 1;
          } else if (datum.status_sip === "RV" && datum.status === "ATOS") {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[0].value = data[0].value + 1;
          } else if (
            datum.status_sip === "BQSUPER" &&
            datum.status === "BQSUPER"
          ) {
            let isPermission = groupsPermission.filter(
              (group) => datum.id_grupo === group
            );
            if (isPermission.length !== 0) data[3].value = data[3].value + 1;
          }
        });

        let tempIdle = FiltersManager.filter_manager_status.filter(
          (filt) => filt === 1
        );
        let tempAnswer = FiltersManager.filter_manager_status.filter(
          (filt) => filt === 2
        );
        let tempReason = FiltersManager.filter_manager_status.filter(
          (filt) => filt === 3
        );
        let tempOff = FiltersManager.filter_manager_status.filter(
          (filt) => filt === 5
        );

        data.map((datum, index) => {
          if (
            tempAnswer.length !== 0 &&
            datum.label === "Atendimento" &&
            datum.value !== 0
          ) {
            countOperators += datum.value;
            temp.push(datum);
          }

          if (
            tempIdle.length !== 0 &&
            datum.label === "Livre" &&
            datum.value !== 0
          ) {
            countOperators += datum.value;
            temp.push(datum);
          }

          if (
            tempOff.length !== 0 &&
            datum.label === "Deslogado" &&
            datum.value !== 0
          ) {
            countOperators += datum.value;
            temp.push(datum);
          }

          if (
            tempReason.length !== 0 &&
            datum.label === "Pausado" &&
            datum.value !== 0
          ) {
            countOperators += datum.value;
            temp.push(datum);
          }
        });

        setDataStatus(temp);
      }
    }
  }, [usersReduce, FiltersManager, GroupsPermissionSupervisor]);

  return (
    <div className={`manager-component__card-status-operators ${classname}`}>
      <div className="manager-component__card-status-operators__title">
        <TextMedium text={title} color="gray" />
      </div>
      <div
        className={
          LoginCompleteReducer.isLoginComplete && countOperators !== 0
            ? "manager-component__card-status-operators__box"
            : "manager-component__card-status-operators__box-empty"
        }
      >
        {LoginCompleteReducer.isLoginComplete ? (
          countOperators !== 0 ? (
            <>
              <div className="manager-component__card-status-operators__box-chart">
                <div className="manager-component__card-status-operators__root">
                  <ResponsivePie
                    data={dataStatus}
                    margin={{ top: 10, right: 0, bottom: 10, left: -15 }}
                    innerRadius={0.6}
                    padAngle={0}
                    cornerRadius={0}
                    activeInnerRadiusOffset={8}
                    borderWidth={1}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 0.2]],
                    }}
                    enableArcLinkLabels={false}
                    arcLinkLabelsSkipAngle={10}
                    arcLinkLabelsTextColor="#333333"
                    arcLinkLabelsThickness={2}
                    arcLinkLabelsColor={{ from: "color" }}
                    arcLabelsSkipAngle={10}
                    arcLabelsTextColor="#f6f4f4"
                    defs={[
                      {
                        id: "dots",
                        type: "patternDots",
                        background: "inherit",
                        color: "rgba(255, 255, 255, 0.3)",
                        size: 4,
                        padding: 1,
                        stagger: true,
                      },
                      {
                        id: "lines",
                        type: "patternLines",
                        background: "inherit",
                        color: "rgba(255, 255, 255, 0.3)",
                        rotation: -45,
                        lineWidth: 6,
                        spacing: 10,
                      },
                    ]}
                    colors={{ datum: "data.color" }}
                  />
                  <div
                    className="manager-component__card-status-operators__root-overlay"
                    style={{
                      paddingLeft:
                        countOperators < 10
                          ? "41%"
                          : countOperators > 999
                          ? "31%"
                          : "38%",
                    }}
                  >
                    <strong>{countOperators}</strong>
                    {/* <span>Operadores</span> */}
                  </div>
                </div>
              </div>
              <div className="manager-component__card-status-operators__box-itens">
                <ul>
                  {dataStatus.map((datum, index) => (
                    <div className="box-list__legends" key={index}>
                      <div
                        className="box-list__legends-circle"
                        style={{ backgroundColor: datum.color }}
                      ></div>
                      <Tooltippy content={datum.label}>
                        <span className="box-list__legends-text">
                          {datum.label}
                        </span>
                      </Tooltippy>
                    </div>
                  ))}
                </ul>
              </div>
            </>
          ) : (
            <div className="manager_empty-state">
              <EmptyState />
            </div>
          )
        ) : (
          <div className="card-status_loading">
            <LoadingStatusOperator />
          </div>
        )}
      </div>
    </div>
  );
}
